import React from 'react';
import { Link } from 'react-router-dom';
import { HiOutlineEmojiSad } from 'react-icons/hi';
import { IoIosHome } from 'react-icons/io';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import { png } from 'utils/imgList';
import { color } from 'styles/pallete';
import { UseTranslationProps } from 'types/UseTranslationProps';

export default function PageNotFound() {
	const { t }: UseTranslationProps = useTranslation();

	return (
		<S.container>
			<img src={png.logoPreta} alt="logo" />

			<S.notice>
				<HiOutlineEmojiSad
					style={{
						color: '#00427C',
						fontSize: '80px',
						cursor: 'pointer'
					}}
				/>

				<h2>{t('pageNotFound.title')}</h2>
				<p>{t('pageNotFound.info')}</p>

				<Link to="/">
					<S.btnHome>
						<IoIosHome
							style={{
								color: color.interface.white,
								fontSize: '20px',
								cursor: 'pointer'
							}}
						/>
						{t('pageNotFound.btnHome')}
					</S.btnHome>
				</Link>
			</S.notice>
		</S.container>
	);
}
